import { render, staticRenderFns } from "./TifTurnoExport.vue?vue&type=template&id=0e9a5a47"
import script from "./TifTurnoExport.vue?vue&type=script&lang=js"
export * from "./TifTurnoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports